import React from "react";
import { AppBtn } from "../../ui/buttons";
import Modal, { ModalBody, ModalFooter } from "../../ui/modal";
import { ProductItemInterface } from "@/assets/interfaces";
import ProductItem from "../items/product-item";
import ProductItemLoader from "../items/product-item-loader";

interface Props {
  show: boolean;
  toggle: (state: boolean) => void;
  items: ProductItemInterface[];
  openItem: (item: ProductItemInterface) => void;
}

const ProductsModal: React.FC<Props> = ({ show, toggle, items, openItem }) => {
  // const switchTab = (tab: number) => tabs.switchTab(tab);
  // const tabs = useTabs(["About Us", "Testimonials"], 0);

  return (
    <Modal {...{ show, toggle }} title="Products in Highlight" bgClose={false} size="midi">
      <ModalBody className="p-5 pt-5 sm:pt-3">
        <div className="space-y-5">
          <p className="text-black-muted text-1sm md:text-1sm mb-2.5">
            You can easily browse and add your preferred products to your cart from this page.
          </p>
          <div className="grid grid-cols-2 gap-6 sm:gap-7.5  lg:gap-10">
            {items && items?.length > 0
              ? items.map((item, index) => (
                  <ProductItem index={index} key={item.id} openItem={() => openItem(item)} item={item} />
                ))
              : Array.from(Array(8).keys()).map((_, index) => <ProductItemLoader key={index} />)}
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ProductsModal;
